import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-page-loader',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './page-loader.html',
    styleUrls: ['./page-loader.scss']
})
export class PageLoaderComponent implements OnInit, OnDestroy {
    isLoading = false;
    private subscription!: Subscription;

    constructor(private loaderService: LoaderService) {}

    ngOnInit(): void {
        this.subscription = this.loaderService.loading$.subscribe(
            (loading) => this.isLoading = loading
        );
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
